import React, { useState, useEffect } from 'react';

export const VideoPreloader = ({ onComplete }) => {
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    const video = document.getElementById('preloader-video');
    
    // Fallback timeout to ensure preloader doesn't block indefinitely
    const fallbackTimeout = setTimeout(() => {
      console.log('Preloader fallback timeout triggered');
      setIsPlaying(false);
      onComplete();
    }, 6000); // 6 seconds fallback
    
    if (video) {
      video.play().catch(err => {
        console.log('Video play failed:', err);
        // If video fails to play, trigger completion immediately
        setIsPlaying(false);
        onComplete();
      });
      
      video.addEventListener('ended', () => {
        clearTimeout(fallbackTimeout);
        setIsPlaying(false);
        setTimeout(() => {
          onComplete();
        }, 0);
      });
      
      video.addEventListener('error', () => {
        console.log('Video error occurred');
        clearTimeout(fallbackTimeout);
        setIsPlaying(false);
        onComplete();
      });
    }
    
    return () => {
      clearTimeout(fallbackTimeout);
    };
  }, [onComplete]);

  if (!isPlaying) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center">
      <video
        id="preloader-video"
        className="max-w-full max-h-full object-contain"
        style={{
          width: 'auto',
          height: 'auto',
          maxWidth: '100vw',
          maxHeight: '100vh'
        }}
        autoPlay
        muted
        playsInline
        preload="auto"
      >
        <source
          src="https://customer-assets.emergentagent.com/job_eb3e5c94-2f85-4e1f-91b8-a1b5d67e6202/artifacts/kbhde7w2_ANIMAZIONE_DP.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  );
};